declare var ajaxData: { ajaxNonce: string, ajaxUrl: string };
declare var ajaxDataMain: { ajaxNonce: string, ajaxUrl: string };

export interface regI {
    error_code: number,
    msg: string,
    sso_user: object,
    user: object
}

export interface logI {
    error_code: number,
    msg: string,
    sso_user: object,
    user: object,
    redirect: string
}

export class AuthHandler {

    registrationForm: HTMLFormElement;
    registerSubmit: HTMLElement;
    registrationMessages: HTMLElement;

    loginForm: HTMLFormElement;
    loginSubmit: HTMLElement;
    loginMessages: HTMLElement;

    constructor() {
        this.init();
    }

    init() {
        this.registrationForm = document.getElementById('sso_registration_form') as HTMLFormElement;
        this.registerSubmit = document.getElementById('sso_register') as HTMLFormElement;
        this.registrationMessages = document.getElementById('registration-messages');

        this.loginForm = document.getElementById('sso_login_form') as HTMLFormElement;
        this.loginSubmit = document.getElementById('sso_login_submit') as HTMLElement;
        this.loginMessages = document.getElementById('login-messages');


        if (this.registrationForm) {
            this.initRegistration();
        }

        if (this.loginForm) {
            this.initLogin();
        }
    }

    initRegistration() {
        if (this.registerSubmit) {
            this.registerSubmit.addEventListener('click', (e) => {
                e.preventDefault();
                let valid = this.registrationForm.checkValidity();

                if (typeof this.registrationForm.reportValidity !== 'undefined') {
                    this.registrationForm.reportValidity();
                }

                if (valid) {
                    let data = {
                        action: 'sta_authenticate',
                        ajx_action: 'register',
                        nonce: ajaxData.ajaxNonce,
                        given_name: (document.getElementById('given_name') as HTMLInputElement).value,
                        family_name: (document.getElementById('family_name') as HTMLInputElement).value,
                        email: (document.getElementById('email') as HTMLInputElement).value,
                        salut: (document.getElementById('salut') as HTMLInputElement).value,
                        newsletterOptIn: (document.getElementById('newsletterOptIn') as HTMLInputElement).checked,
                        industrySector: (document.querySelector('input[name="industrySector"]:checked') as HTMLInputElement).value
                    }

                    this.hideMessages();
                    this.loader();

                    jQuery.when(jQuery.ajax({
                        type: "POST",
                        url: ajaxData.ajaxUrl,
                        data: data,
                    })).then((res: regI) => {
                        console.log(res);
                        this.loader(false);
                        if (res.sso_user && res.user) {
                            this.renderInfo(this.registrationMessages, res.msg, res.error_code);
                            this.registerSubmit.style.display = 'none';
                        } else if (res.error_code) {
                            this.renderError(this.registrationMessages, res.msg, res.error_code);
                        }
                    }).fail(e => {
                        console.error(e);
                        this.loader(false)
                        this.renderError(this.registrationMessages, '', 0);
                    });

                } else {
                    console.error('invalid form');
                }
            })
        }
    }

    initLogin() {
        if (this.loginSubmit) {
            this.loginSubmit.addEventListener('click', (e) => {
                e.preventDefault();
                this.loginFormSubmit();
            })
        }

        document.onkeydown = (event) => {
            if (event.keyCode == 13) {
                this.loginFormSubmit();
            }
        }
    }

    loginFormSubmit() {
        let valid = this.loginForm.checkValidity();

        if (typeof this.loginForm.reportValidity !== 'undefined') {
            this.loginForm.reportValidity();
        }

        if (valid) {
            this.login({
                action: 'sta_authenticate',
                ajx_action: 'login',
                nonce: ajaxData.ajaxNonce,
                email: (document.getElementById('sso_email') as HTMLInputElement).value,
                password: (document.getElementById('sso_password') as HTMLInputElement).value,
                remember: (document.getElementById('sso_rememberme') as HTMLInputElement)?.checked || false
            })
        } else {
            console.error('invalid form');
        }
    }

    login(data: object) {
        this.hideMessages();
        this.loader();

        jQuery.when(jQuery.ajax({
            type: "POST",
            url: ajaxDataMain.ajaxUrl,
            data: data,
        })).then((res: logI) => {
            if (res.error_code === 0) {
                if (res.redirect) {
                    window.location.href = res.redirect;
                } else {
                    window.location.href = location.origin;
                }
            } else {
                this.loader(false);
                this.renderError(this.loginMessages, res.msg, res.error_code)
            }
        }).fail(e => {
            console.error(e);
            this.loader(false);
            this.renderError(this.loginMessages, '', 0);
        });
    }

    hideMessages() {
        if (this.registrationMessages) {
            this.registrationMessages.innerHTML = '';
        }
        if (this.loginMessages) {
            this.loginMessages.innerHTML = '';
        }
    }

    loader(start = true) {
        if (start) {
            jQuery(".start-loader").fadeIn("slow");
        } else {
            jQuery(".start-loader").fadeOut("slow");
        }
    }

    renderError(cnt: HTMLElement, msg: string, code: number) {
        if (cnt) {
            msg = msg || 'Ein unbekannter Fehler ist aufgetreten, bitte kontaktieren Sie den Kundenservice.';
            let error = document.createElement('div');
            error.classList.add('message', 'error')
            error.innerHTML = `<strong>Fehler</strong>: ${msg}`;
            cnt.appendChild(error);
            cnt.scrollIntoView({block: "end", behavior: "smooth"});
        }
    }

    renderInfo(cnt: HTMLElement, msg: string, code: number) {
        if (cnt && msg) {
            let error = document.createElement('div');
            error.classList.add('message', 'success')
            error.innerHTML = `<strong>Erfolg</strong>: ${msg}`;
            cnt.appendChild(error);
            cnt.scrollIntoView({block: "end", behavior: "smooth"});
        }
    }
}